import React from 'react';
import { Link } from 'react-router-dom';
import HorizontalScrollStrip from '../HorizontalScrollStrip';

/**
 * Editorial product shelf section — shared by featured, recently viewed, etc.
 */
export default function ProductShelfSection({
  eyebrow = '',
  title,
  lead = '',
  actionHref = '',
  actionLabel = '',
  headerAddon = null,
  layout = 'scroll',
  tone = 'default',
  className = '',
  ariaLabel = 'Products',
  children,
}) {
  const useGrid = layout === 'grid';

  const isExternalAction = /^https?:\/\//i.test(String(actionHref || ''));
  const actionText = String(actionLabel || '').replace(/\s*[→›»]\s*$/u, '').trim();

  return (
    <section className={`product-shelf product-shelf--${tone} ${className}`.trim()}>
      <div className="product-shelf__band" aria-hidden="true" />
      <div className="container store-page__container product-shelf__container">
        <header className="product-shelf__head">
          <div className="product-shelf__head-copy">
            {eyebrow ? <p className="product-shelf__eyebrow">{eyebrow}</p> : null}
            <h2 className="product-shelf__title">{title}</h2>
            {lead ? <p className="product-shelf__lead">{lead}</p> : null}
          </div>
          {headerAddon ? <div className="product-shelf__addon">{headerAddon}</div> : null}
          {actionHref && actionLabel ? (
            isExternalAction ? (
              <a
                href={actionHref}
                className="product-shelf__action btn btn-outline-primary btn-sm rounded-pill"
                target="_blank"
                rel="noopener noreferrer"
              >
                {actionText}
              </a>
            ) : (
              <Link
                to={actionHref}
                className="product-shelf__action btn btn-outline-primary btn-sm rounded-pill"
              >
                {actionText}
              </Link>
            )
          ) : null}
        </header>

        {useGrid ? (
          <div className="product-shelf__grid" aria-label={ariaLabel}>
            {children}
          </div>
        ) : (
          <HorizontalScrollStrip
            className="product-shelf__scroll-wrap"
            trackClassName="product-shelf__track"
            ariaLabel={ariaLabel}
          >
            {children}
          </HorizontalScrollStrip>
        )}
      </div>
    </section>
  );
}
